import React, { useEffect, useState } from "react";
import "../../EcoPalmProducts/EcoPalmProducts.css";
import Card from "../../../../../components/Card";
import Breadcrumb from "../../../../../components/Breadcrum";
import { Modal } from "bootstrap";
import { useNavigate } from "react-router-dom";

/* ================= IMAGES ================= */

const images = {
  banner: "./assets/img/contact-banner.png",
  BlackPepper: "/assets/img/Spices/Black-pepper.jpg",
  GreenCardamom: "/assets/img/Spices/Green-cardamom.jpg",
  Nutmeg: "/assets/img/Spices/Nutmeg.jpg",
  Mace: "/assets/img/Spices/Mace.jpg",
  Cloves: "/assets/img/Spices/Cloves.jpg",
  Turmeric: "/assets/img/Spices/Turmeric.jpg",
  DryGinger: "/assets/img/Spices/Dry-ginger.jpg",
  Cinnamon: "/assets/img/Spices/Cinnamon.jpg",
  CuminSeeds: "/assets/img/Spices/Cumin-seeds.jpg",
  CorianderSeeds: "/assets/img/Spices/Coriander-seeds.jpg",
  FennelSeeds: "/assets/img/Spices/Fennel-seeds.jpg",
  RedChillies: "/assets/img/Spices/Red-chilies.jpg",
  StarAnise: "/assets/img/Spices/Star-anise.jpg",

  // BirdsEyeChilies: "/assets/img/Spices/Birds-Eye-Chilies.jpg",
  // ChilliFlakes: "/assets/img/Spices/Chilli-Flakes.jpg",
  // FenugreekSeed: "/assets/img/Spices/Fenugreek-Seed.jpg",
  // NigellaSeedKalongi: "/assets/img/Spices/Nigella-Seed-Kalongi.jpg",
  // MustardSeed: "/assets/img/Spices/Mustard-Seed.jpg",
  // Ginger: "/assets/img/Spices/Ginger.jpg",
  // Chickpea: "/assets/img/Spices/Chickpea.jpg",
  // SesameSeed: "/assets/img/Spices/Sesame-Seed.jpg",
  // DriedMint: "/assets/img/Spices/Dried-Mint.jpg",
  // TableSalt: "/assets/img/Spices/Table-Salt.jpg",
  // RockSalt: "/assets/img/Spices/Rock-Salt.jpg",
  // BlackSalt: "/assets/img/Spices/Black-Salt.jpg",
  // HimalayanPinkSalt: "/assets/img/Spices/Himalayan-Pink-Salt.jpg",
};

/* ================= CARD DATA ================= */

const cardData = [

  {
    id: "Black Pepper",
    image: images.BlackPepper,
    description: "Known as the “King of Spices,” Black Pepper is one of India's most valued and widely traded spices. It is appreciated for its distinctive pungency, rich aroma, and versatile culinary applications. Our Black Pepper is carefully sourced from quality-growing regions and selected to meet the requirements of international buyers.",
    availableforms: "Whole | Crushed | Powder",
  },
{
    id: "Green Cardamom",
    image: images.GreenCardamom,
    description: "Green Cardamom is a premium aromatic spice known for its sweet fragrance and distinctive flavour. Widely used in food, beverages, confectionery, and culinary preparations, Indian Cardamom is highly valued in global markets. We supply carefully selected Green Cardamom with natural aroma, vibrant colour, and consistent quality.",
    availableforms: "Whole | Seeds | Powder",
  },
{
    id: "Nutmeg",
    image: images.Nutmeg,
    description: "Nutmeg is an aromatic spice obtained from the seed of the nutmeg tree. It is widely used in culinary preparations, bakery products, beverages, pharmaceuticals, and cosmetics. Sourced from premium growing regions, our Nutmeg is carefully selected to retain its natural aroma, flavour, and essential characteristics.",
    availableforms: "Whole | Broken | Powder",
  },
  {
    id: "Mace",
    image: images.Mace,
    description: "Mace is the delicate outer covering of the Nutmeg seed and is prized for its warm aroma and distinctive flavour. It is widely used in culinary, food processing, pharmaceutical, and cosmetic applications. Our Mace is carefully sourced and processed to ensure premium quality and natural characteristics.",
    availableforms: "Whole | Broken | Powder",
  },
{
    id: "Cloves",
    image: images.Cloves,
    description: "Cloves are highly aromatic flower buds known for their intense flavour and rich essential oil content. They are widely used in food preparations, beverages, pharmaceuticals, and personal care products. We supply carefully selected Cloves with strong aroma, natural colour, and consistent quality suitable for international markets.",
    availableforms: "Whole | Powder",
  },
{
    id: "Turmeric",
    image: images.Turmeric,
    description: "Turmeric is one of India's most recognised spices, valued for its vibrant colour, earthy flavour, and natural properties. It is widely used in food, beverages, cosmetics, and various industrial applications. Our Turmeric is sourced from reliable growing regions and supplied in carefully processed forms.",
    availableforms: "Whole Fingers | Powder",
  },
{
    id: "Dry Ginger",
    image: images.DryGinger,
    description: "Dry Ginger is a versatile spice known for its warm aroma and strong flavour. It is widely used in food products, beverages, bakery items, confectionery, and traditional preparations. We offer quality Dry Ginger carefully sourced and processed to retain its natural characteristics.",
    availableforms: "Whole | Slices | Powder",
  },
{
    id: "Cinnamon",
    image: images.Cinnamon,
    description: "Cinnamon is a highly valued aromatic spice known for its sweet and warm flavour. It is widely used in food products, bakery, beverages, confectionery, and flavouring applications. Our Cinnamon is carefully sourced and supplied in various forms according to customer requirements.",
    availableforms: "Quills | Broken | Powder",
  },
{
    id: "Cumin Seeds",
    image: images.CuminSeeds,
    description: "Cumin is a popular spice known for its distinctive earthy aroma and warm flavour. It is widely used in culinary preparations, spice blends, food processing, and seasoning products. We supply carefully cleaned and selected Cumin Seeds suitable for domestic and international markets.",
    availableforms: "Whole Seeds | Powder",
  },
{
    id: "Coriander",
    image: images.CorianderSeeds,
    description: "Coriander is an essential spice widely used for its fresh aroma and mild citrus-like flavour. It is commonly used in food preparation, spice blends, seasonings, and food processing industries. Our Coriander products are sourced from reliable agricultural regions and processed with attention to quality and purity.",
    availableforms: "Whole Seeds | Split | Powder",
  },
{
    id: "Fennel Seeds",
    image: images.FennelSeeds,
    description: "Fennel Seeds are known for their naturally sweet aroma and refreshing flavour. They are widely used in culinary preparations, beverages, confectionery, mouth fresheners, and food processing. We supply carefully selected Fennel Seeds with natural aroma and consistent quality.",
    availableforms: "Whole Seeds | Powder",
  },
{
    id: "Red Chillies",
    image: images.RedChillies,
    description: "Indian Red Chillies are internationally recognised for their vibrant colour, pungency, and rich flavour. They are widely used in food processing, spice blends, sauces, seasonings, and culinary preparations. We offer selected varieties according to customer requirements for colour, pungency, and application.",
    availableforms: "Whole | Crushed | Flakes | Powder",
  },
{
    id: "Star Anise",
    image: images.StarAnise,
    description: "Star Anise is a distinctive aromatic spice known for its characteristic star-shaped appearance and sweet, licorice-like flavour. It is widely used in culinary preparations, spice blends, beverages, and flavouring applications. Our Star Anise is carefully sourced and selected to ensure natural aroma and quality.",
    availableforms: "Whole | Broken | Powder",
  },
  
  // {
  //   id: "BirdsEyeChilies",
  //   image: images.BirdsEyeChilies,
  //   description:
  //     "Hot and flavorful chilies known for their intense pungency and use in sauces, seasonings, and spicy dishes.",
  //   origin: "India",
  //   season: "January to December",
  // },
  // {
  //   id: "ChilliFlakes",
  //   image: images.ChilliFlakes,
  //   description:
  //     "Crushed dried chilies used to add heat, flavor, and texture to a variety of food preparations.",
  //   origin: "India",
  //   season: "January to December",
  // },
  // {
  //   id: "FenugreekSeed",
  //   image: images.FenugreekSeed,
  //   description:
  //     "Nutritious spice seeds known for their distinctive flavor and use in food processing and traditional recipes.",
  //   origin: "India",
  //   season: "January to December",
  // },
  // {
  //   id: "NigellaSeedKalongi",
  //   image: images.NigellaSeedKalongi,
  //   description:
  //     "Premium black seeds with a unique flavor profile, commonly used in baking, seasoning, and spice blends.",
  //   origin: "India",
  //   season: "January to December",
  // },
  // {
  //   id: "MustardSeed",
  //   image: images.MustardSeed,
  //   description:
  //     "Widely used spice seed known for its pungent flavor and application in pickles, seasonings, and sauces.",
  //   origin: "India",
  //   season: "January to December",
  // },
  // {
  //   id: "Ginger",
  //   image: images.Ginger,
  //   description:
  //     "Fresh and flavorful spice widely used in culinary preparations, beverages, and traditional wellness products.",
  //   origin: "India",
  //   season: "January to December",
  // },
  // {
  //   id: "Chickpea",
  //   image: images.Chickpea,
  //   description:
  //     "Premium-quality chickpeas rich in nutrition and widely used in food processing and culinary applications.",
  //   origin: "India",
  //   season: "January to December",
  // },
  // {
  //   id: "SesameSeed",
  //   image: images.SesameSeed,
  //   description:
  //     "Nutritious oil-rich seeds widely used in bakery products, confectionery, cooking, and food manufacturing.",
  //   origin: "India",
  //   season: "January to December",
  // },
  // {
  //   id: "DriedMint",
  //   image: images.DriedMint,
  //   description:
  //     "Naturally dried mint leaves offering refreshing flavor and aroma for culinary and beverage applications.",
  //   origin: "India",
  //   season: "January to December",
  // },
  // {
  //   id: "TableSalt",
  //   image: images.TableSalt,
  //   description:
  //     "Refined food-grade salt widely used for seasoning, food preservation, and industrial food applications.",
  //   origin: "India",
  //   season: "January to December",
  // },
  // {
  //   id: "RockSalt",
  //   image: images.RockSalt,
  //   description:
  //     "Natural mineral-rich salt valued for its purity and use in culinary and food processing industries.",
  //   origin: "India",
  //   season: "January to December",
  // },
  // {
  //   id: "BlackSalt",
  //   image: images.BlackSalt,
  //   description:
  //     "Traditional mineral salt known for its distinctive flavor and use in culinary and seasoning applications.",
  //   origin: "India",
  //   season: "January to December",
  // },
  // {
  //   id: "HimalayanPinkSalt",
  //   image: images.HimalayanPinkSalt,
  //   description:
  //     "Premium pink salt renowned for its natural minerals, purity, and culinary versatility.",
  //   origin: "India",
  //   season: "January to December",
  // },
];

/* ================= COMPONENT ================= */

export default function Spices() {
  const [selectedProduct, setSelectedProduct] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  /* ================= OPEN MODAL ================= */

  const openModal = (product) => {
    setSelectedProduct(product);

    setTimeout(() => {
      const modalElement = document.getElementById("productModal");

      if (modalElement) {
        const modal = new Modal(modalElement);
        modal.show();
      }
    }, 100);
  };

  /* ================= ENQUIRE BUTTON ================= */

  const handleEnquire = () => {
    const modalElement = document.getElementById("productModal");

    if (modalElement) {
      const modalInstance =
        Modal.getInstance(modalElement) || new Modal(modalElement);

      modalInstance.hide();
    }

    // Small delay so modal closes smoothly before changing page

    setTimeout(() => {
      navigate("/contact");

      // Scroll smoothly to the top of Contact page

      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, 100);
    }, 300);
  };

  return (
    <>
      {/* ================= BREADCRUMB ================= */}

      <Breadcrumb title="Spices" backgroundImage={images.banner} height="40vh"/>

      {/* ================= PRODUCTS ================= */}

      <div className="cardContainer mb-5 pt-5">
        <div className="container">
          <div className="row g-lg-5 g-4">
            {cardData.map((card) => (
              <div key={card.id} className="col-lg-4 col-md-6 col-12">
                <div onClick={() => openModal(card)} style={{ cursor: "pointer" }}>
                  <Card image={card.image}/>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* ================= MODAL ================= */}

      <div className="modal fade" id="productModal" tabIndex="-1" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">

            {/* MODAL HEADER */}

            <div className="modal-header">
              <h5 className="modal-title">{selectedProduct?.id}</h5>

              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            {/* MODAL BODY */}

            <div className="modal-body">
              <div className="text-center mb-4">
                <img src={selectedProduct?.image} alt={selectedProduct?.id} className="img-fluid rounded" style={{ maxHeight: "300px" }}/>
              </div>

              <p><strong>Description :</strong>{" "} {selectedProduct?.description}</p>

              <p><strong>Available Forms :</strong>{" "} {selectedProduct?.availableforms}</p>
            </div>

            {/* MODAL FOOTER */}

            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>

              {/* ENQUIRE BUTTON */}

              <button type="button" className="btn btn-primary" onClick={handleEnquire}>Enquire Now</button>

            </div>
          </div>
        </div>
      </div>
    </>
  );
}